<div class="col-12 d-flex" style="justify-content: center; align-items: center; flex: 1;">
    <div class="col-12 col-md-11 col-lg-10 col-xl-9 col-xxl-8 mt-5 mb-5 d-flex"
        style="justify-content: center; align-items: center; flex-wrap: wrap;">
        
        <!-- Header Section with Logo and Settings -->
        <div class="col-12 d-flex" style="justify-content: space-between; align-items: center; margin-bottom: 2rem;">
            <!-- Logo -->
            <div class="logo-container">
                <img class="logo" src="../../../assets/Logo copy.png" alt="Aivoria">
            </div>
            
            <!-- Language and Settings -->
            <div class="d-flex" style="align-items: center;">
                <span class="language me-4 dropdown-toggle" id="dropdownLanguageSelect" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false" style="text-transform: uppercase;">
                    {{ languageMode }}
                    <span>
                        <img class="dropdown-rotate" width="20px" height="20px" src="../../../assets/arrow-up-down.svg">
                    </span>
                </span>
                <div class="dropdown-menu dropdown-menu-right py-2" aria-labelledby="dropdownLanguageSelect">
                    <div class="col-12 dropdown-item" (click)="setLanguage('en')"
                        style="color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
                        English
                    </div>
                    <div class="col-12 dropdown-item" (click)="setLanguage('nl')"
                        style="color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
                        Dutch
                    </div>
                </div>
                <div class="dropdown" style="cursor: pointer;">
                    <img class="me-3 info-img dropdown-toggle" src="../../../assets/setting-icon.svg" alt="setting"
                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        [class.rotate]="isRotated" (mouseenter)="rotateImage(true)" (mouseleave)="rotateImage(false)">
                    <div class="dropdown-menu dropdown-menu-right py-2" aria-labelledby="dropdownMenuButton">
                        <div class="col-12 dropdown-item" (click)="openDocumentation()"
                            style="color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
                            {{ "common.Documentation" | translate }}
                        </div>
                        <div class="col-12 dropdown-item mt-1" (click)="notifySidebarActivePage(7)" style=" color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor:
                            pointer;">
                            {{ "common.Notification" | translate }}
                        </div>
                        <div class="col-12 dropdown-item mt-1" (click)="logout()"
                            style="color: #151c43; line-height: 22px; font-size: calc(var(--font-medium)); cursor: pointer;">
                            {{ "common.Logout" | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Welcome Heading -->
        <div class="col-12 head">
            {{ "ChooseSubscription.Welcome! to Aivoria" | translate }}
        </div>

        <!-- Description and Billing Toggle -->
        <div class="col-12 pt-4 d-flex" style="justify-content: center; align-items: center; flex-wrap: wrap;">
            <div class="col-md-6 col-lg-7 col-12 desc">
                {{
                "Subscription.ChoosePlan"
                | translate
                }}
            </div>
            <div class="col-md-6 col-lg-5 col-12 pt-md-0 pt-2 d-flex"
                style="justify-content: end; align-items: center;">
                <div class="discount-container">
                    <div class="col-md-9 col-8">
                        <div class="discount-badge-top">{{
                "Subscription.Discount"
                | translate
                }}</div>
                        <div class="col-12 tab-back p-1">
                            <div class="col-12 d-flex" style="justify-content: space-between; align-items: center;">
                                <div class="col-6">
                                    <button type="button" class="btn"
                                        style="width: 100%; border: none; border-radius: 21px;"
                                        (click)="toggleBillingPeriod()"
                                        [ngClass]="{'plan-btn-active': isYearlyBilling, 'inactive-btn': !isYearlyBilling}">
                                        {{ "Subscription.Button.Yearly" | translate }}
                                    </button>
                                </div>
                                <div class="col-6 d-flex" style="justify-content: end;">
                                    <button type="button" class="btn"
                                        style="width: 100%; border: none; border-radius: 21px;"
                                        (click)="toggleBillingPeriod()"
                                        [ngClass]="{'plan-btn-active': !isYearlyBilling, 'inactive-btn': isYearlyBilling}">
                                        {{ "Subscription.Button.Monthly" | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Subscription Cards -->
        <div class="col-12 pt-4">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
                <div class="col" *ngFor="let plan of subscriptionPlans; let i = index;">
                    <div class="card" [class.card-selected]="selectedCardIndex === i" (mouseenter)="selectCard(i)"
                        (click)="selectCard(i)">

                        <div class="card-body">
                            <!-- Plan Name -->
                            <div class="card-title">
                                {{ 'Subscription.' + plan.name | translate }}
                            </div>

                            <!-- Price -->
                            <div class="card-price-container">
                                <span class="card-price">{{getCurrentPrice(i)}}</span>
                                <span class="card-period">/{{ "Subscription." + getCurrentPeriodText() | translate
                                    }}</span>
                            </div>

                            <!-- Chat Limit Dropdown -->
                            <div class="pt-3">
                                <label class="form-label">
                                    {{ "Subscription.Chats / Month" | translate }}
                                </label>
                                <select class="form-select" [ngModel]="selectedChatOptions[i] || 0"
                                    (ngModelChange)="onChatSelectionChange(i, $event)" [disabled]="isLoadingTrail">
                                    <option *ngFor="let chatOption of plan.chatOptions; let j = index" [value]="j">
                                        {{chatOption.chats | number}} Chats
                                    </option>
                                </select>
                            </div>

                            <!-- Divider -->
                            <hr>

                            <!-- Features List -->
                            <div class="pt-2 d-flex" style="align-items: flex-start;">
                                <span class="point"
                                    [ngStyle]="{ 'background-color': selectedCardIndex === i ? '#FFE4B6' : '#ffffff' }">
                                </span>
                                <span class="ms-2 card-text"
                                    [ngStyle]="{ 'color': selectedCardIndex === i ? '#ffffff' : '#7a7a7a' }">
                                    {{ 'Subscription.' + plan.pt1 | translate }}
                                </span>
                            </div>
                            <div class="pt-2 d-flex" style="align-items: flex-start;">
                                <span class="point"
                                    [ngStyle]="{ 'background-color': selectedCardIndex === i ? '#FFE4B6' : '#ffffff' }">
                                </span>
                                <span class="ms-2 card-text"
                                    [ngStyle]="{ 'color': selectedCardIndex === i ? '#ffffff' : '#7a7a7a' }">
                                    {{ 'Subscription.' + plan.pt2 | translate }}
                                </span>
                            </div>
                            <div class="pt-2 d-flex" style="align-items: flex-start;">
                                <span class="point"
                                    [ngStyle]="{ 'background-color': selectedCardIndex === i ? '#FFE4B6' : '#ffffff' }">
                                </span>
                                <span class="ms-2 card-text"
                                    [ngStyle]="{ 'color': selectedCardIndex === i ? '#ffffff' : '#7a7a7a' }">
                                    {{ 'Subscription.' + plan.pt3 | translate }}
                                </span>
                            </div>

                            <!-- CTA Button -->
                            <div class="pt-4">
                                <button type="button" class="btn card-cta-btn"
                                    (click)="callUserSubscription(getSelectedPlanId(i))" [disabled]="isLoadingTrail"
                                    [ngClass]="{ 'selected': selectedCardIndex === i }">
                                    <span *ngIf="!isLoadingTrail">{{ 'Subscription.Button.' + plan.btn | translate }}</span>
                                    <span *ngIf="isLoadingTrail && selectedCardIndex === i">
                                        <span class="spinner-border spinner-border-sm me-2" role="status"
                                            aria-hidden="true"></span>
                                        Loading...
                                    </span>
                                    <span *ngIf="isLoadingTrail && selectedCardIndex !== i">{{ 'Subscription.Button.' + plan.btn | translate }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>